import { User } from 'module/api/user/types';
import { getRandomColor } from 'module/helpers/get-random-color';
import { UserOption } from 'module/types/filter-field/field/filterable-field';
import { getUserLabel } from '../get-user-label';

export const userOption = (user: User): UserOption => {
  return {
    label: getUserLabel(user),
    value: user.userId,
    imageUrl: user.photoUrl,
    description: user.role?.roleName,
    logoUrl: user.company?.companyLogoUrl,
    color: getRandomColor(user.userId),
    emailId: user.emailId,
    extra: {
      id: user.userId,
      type: 'user',
      roleId: user.role?.roleId,
      userStatus: user.userStatus,
      userType: user.userType,
    },
  };
};
